export const API_URL=window.location.host==="localhost:3011"?"http://localhost:5000/api/common":"https://quiz.quizophy.com/api/common"